module.exports = __webpack_public_path__ + "static/media/logo.da30d474.svg";